// React
import React, { Component } from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from '../../actions';

// Components
import { Form, Field } from 'react-final-form'
import { Hero } from '../../components/Hero';
import { FluidSection } from '../../components/FluidSection';
import { Content } from '../../components/Content';
// import { Button } from '../../components/Button';
import { constants } from '../../constants';
// import FlatButton from 'material-ui/FlatButton';
// import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import Select from 'react-select'
import SelectField from 'components/SelectField'
import { isEmail, required, composeValidators } from 'components/Form/validation';

class HelpFeedback extends Component {

    constructor () {
        super();
        this.state = {
          showModal: false,
          heroHeight: '150px',
          heroOrientation: 'row',
          width: 0,
          height: 0
        };
    }
    
    // ########## LIFE CYCLE HOOKS ############## //
    
    componentWillMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
    }
    
    componentDidMount(){
        // Recive window dimetions
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
        
        // Go to the top of the page on load
        document.getElementById('top').scrollIntoView();
    }

    // ########################################### //

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    
    handleSupportTypeChange = (selectSupportType) => {
        this.setState({
            selectSupportType,
        });
    }

    render(){
        const onSubmit = async values => {
            this.props.sendHelpFormData(values, this.props.userData); //TODO SEND THIS TO FIREBASE TO EB SENT TO SLACK
        }

        const SelectFieldAdapter = ({ input, meta, ...rest }) => (
            <div>
                <SelectField 
                    {...input} 
                    {...rest} 
                    searchable 
                    // value={ this.state.selectSupportType }
                    // onChange={this.handleSupportTypeChange}
                />
                <span style={{ color: 'red' }}>{meta.touched ? meta.error : ''}</span>
            </div>
        );

        const TextFieldAdapter = ({ input, meta, ...rest }) => (
            <div>
                <input 
                    {...input}
                    {...rest}
                />
                <span style={{ color: 'red' }}>{meta.touched ? meta.error : ''}</span>
            </div>
        );
        
        const TextAreaFieldAdapter = ({ input, meta, ...rest }) => (
            <div>
                <textarea 
                    {...input}
                    {...rest}
                />
                <span style={{ color: 'red' }}>{meta.touched ? meta.error : ''}</span>
            </div>
        );

        return (
            <div className="MainFeedbackContainer" style={{...constants.layout.container, justifyContent: 'space-between'}}>
                { 
                    <div>
                        <Hero
                            id="feedbackHero"
                            backgroundImageURL={'https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/heroImages%2Fstefan-stefancik-257625-unsplash.jpg?alt=media&token=a47dfac3-2249-45ff-bdac-ca1430991a1a'}
                            height={this.state.heroHeight}
                            orientation={this.state.heroOrientation}
                        />
                       
                        <div style={{ padding: '0 15%', marginBottom: 40, fontSize: constants.text.baseFontStyles.fontSize }}>
                            <div>
                                <FluidSection>
                                    <Content
                                        mainTitleText={'Having trouble ? We\'d love to help!'}
                                        mainTitleTextAlt={'and feedback is great too!'}
                                    />
                                </FluidSection>
                                <Form
                                    onSubmit={onSubmit}
                                    // initialValues={{ stooge: 'larry' }}

                                    validate={ values => {
                                        const errors = {};

                                        if (isEmail(values.email)) {
                                            errors.email = isEmail(values.email);
                                        }
                                        
                                        if (!values.supportType) {
                                            errors.supportType = "Required";
                                        }

                                        if (!values.details) {
                                            errors.details = "Required";
                                        }
                                        return errors;
                                        }
                                    }
                                    
                                    render={({ handleSubmit, reset, submitting, pristine, invalid, values, errors, meta }) => (
                                        <form onSubmit={e => {
                                            handleSubmit(e);
                                            reset();
                                            }}>
                                        <div style={styles.formFieldStyles}>
                                            <label>Name</label>
                                            <Field
                                                style={styles.inputStyles}
                                                name="name"
                                                component={TextFieldAdapter}
                                                type="text"
                                                placeholder="(Optional)"
                                            />
                                        </div>
                                        <div style={styles.formFieldStyles}>
                                            <label>Email (used for support purposes only)</label>
                                            <Field
                                                style={styles.inputStyles}
                                                name="email"
                                                component={TextFieldAdapter}
                                                type="email"
                                                placeholder="Email"
                                                validate={value => {
                                                    return isEmail(value);
                                                }}
                                            />
                                        </div>
                                        <div style={styles.formFieldStyles}>
                                            <label>What is your issue about?</label>
                                            <Field
                                                // style={{ width: }}
                                                name="supportType"
                                                component={SelectFieldAdapter}
                                                options={[ 
                                                    { value: 'billing', label: 'Billing' },
                                                    { value: 'support', label: 'Technical Support' },
                                                    { value: 'bug', label: 'Found a Bug' },
                                                    { value: 'suggestion', label: 'Suggestions & Requests' },
                                                    { value: 'other', label: 'Other' },
                                                ]}
                                                validate={value => {
                                                    return (value ? undefined : 'Required')
                                                }}
                                            />
                                        </div>
                                        <div style={styles.formFieldStyles}>
                                            <label>Feedback/Support Request Details</label>
                                            <Field 
                                                style={{...styles.inputStyles, height: 200}}
                                                name="details" 
                                                component={TextAreaFieldAdapter} 
                                                placeholder="Describe the problem with as much detail as you can, thanks!" 
                                                validate={required}
                                            />
                                        </div>
                                        <div className="buttons">
                                            <button 
                                                style={{...styles.buttonStyles, backgroundColor: (invalid) ? 'lightgray' : constants.color.primary}} 
                                                type="submit" 
                                                disabled={submitting || pristine || invalid}
                                            >
                                                Submit
                                            </button>
                                            {/* <button
                                                style={styles.buttonStyles}
                                                type="button"
                                                onClick={reset}
                                                disabled={submitting || pristine}
                                            >
                                                Reset
                                            </button> */}
                                        </div>
                                        {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                                        </form>
                                    )}
                                    />
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    };
    };


    const styles= {
        inputStyles: { 
            width: '100%', 
            padding: 10, 
            fontSize: 14, 
            borderRadius: 5, 
            borderColor: 'transparent', 
            borderWidth: 0, 
            backgroundColor: 'rgba(220,220,220, 0.6)',
            fontFamily: 'Open Sans',
        },
        formFieldStyles: { 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'flex-start',
            marginBottom: 15 
        },
        buttonStyles: { 
            padding: 10, 
            backgroundColor: constants.color.primary, 
            borderRadius: 5,
            borderWidth: 0,
            fontSize: 14,
            fontFamily: 'Open Sans',
            marginRight: 15,
            color: 'white',
        }
    }
    const mapStateToProps = ({ client }) => {
        return {
            userData: client.clientData
        };
    }

export default connect(mapStateToProps, actions)(HelpFeedback)



// WEBPACK FOOTER //
// ./src/js/containers/HelpFeedback/HelpFeedback.jsx